import type { TOC } from '@ember/component/template-only';
import { array, concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import type ForcJournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    forcComponent: ForcJournalEventBasedComponent;
  };
}

export default <template>
  {{#if @forcComponent.changeset.articularPain}}
    <@form.FieldsRadioGroup
      @propertyName='articularPainSeverity'
      @title={{t 'mici-form.articularPainSeverity.long' htmlSafe=true}}
      as |Group|
    >
      {{#each (array '1' '2' '3' '4') as |value|}}
        <Group.FieldRadio
          @value={{value}}
          @label={{t (concat 'mici-form.articularPainSeverity.answers.' value)}}
        />
      {{/each}}
    </@form.FieldsRadioGroup>
  {{/if}}
</template> satisfies TOC<Signature>;
